import * as React from "react";

import { Skeleton } from "@replo/design-system/components/skeleton/Skeleton";

export default function PageCardSkeleton() {
  return (
    <div className="h-full">
      <div className="border-0.5 border-border rounded-lg bg-sheet flex flex-col shadow-sm h-full">
        <div className="p-4 pb-0 flex flex-col gap-2">
          <div className="flex justify-center gap-4 rounded-b-lg h-[155px] overflow-hidden">
            <div className="w-[200px] h-[360px] pointer-events-none rounded-lg shadow-lg bg-muted flex items-center justify-center">
              <Skeleton className="w-full h-full rounded-lg" />
            </div>
          </div>
        </div>
        <div className="px-4 py-3 flex flex-col gap-2 border-t-0.5 border-border bg-white rounded-b-lg">
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-2">
              <Skeleton className="h-6 w-32 rounded" />
              <Skeleton className="h-6 w-12 rounded" />
            </div>
            <Skeleton className="h-6 w-6 rounded" />
          </div>

          <div className="grid grid-cols-3 w-full">
            <div className="space-y-0.5">
              <p className="text-xs text-placeholder">Sessions</p>
              <Skeleton className="h-6 w-10 rounded" />
            </div>
            <div className="space-y-0.5">
              <p className="text-xs text-placeholder">Revenue</p>
              <Skeleton className="h-6 w-10 rounded" />
            </div>
            <div className="space-y-0.5">
              <p className="text-xs text-placeholder">Conversion</p>
              <Skeleton className="h-6 w-10 rounded" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
